import { render } from "./ModeSelector.vue?vue&type=template&id=5c5f3e58&scoped=true"
import script from "./ModeSelector.vue?vue&type=script&lang=js"
export * from "./ModeSelector.vue?vue&type=script&lang=js"

import "./ModeSelector.vue?vue&type=style&index=0&id=5c5f3e58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c5f3e58"]])

export default __exports__